module.exports = require("./ar-MR.js");